var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified123(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0001,
    cy: 10.3848,
    rx: 5.78497,
    ry: 5.00687,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.537 9.56496L18.1379 7.96603C17.8381 7.66623 17.6382 7.06663 17.6382 6.6669V5.06797C17.6382 3.9687 16.7388 3.16923 15.7395 3.16923H14.0406C13.6409 3.16923 13.0413 2.96937 12.7415 2.66957L11.1426 1.2705C10.443 0.670901 9.34376 0.670901 8.64423 1.2705L7.14523 2.66957C6.84543 2.96937 6.24583 3.16923 5.8461 3.16923H4.14723C3.04796 3.16923 2.2485 4.06863 2.2485 5.06797V6.76683C2.2485 7.16656 2.04863 7.76616 1.74883 8.06596L0.4497 9.6649C-0.1499 10.3644 -0.1499 11.4637 0.4497 12.1632L1.74883 13.7622C2.04863 14.062 2.2485 14.6616 2.2485 15.0613V16.7602C2.2485 17.8594 3.1479 18.6589 4.14723 18.6589H5.8461C6.24583 18.6589 6.84543 18.8588 7.14523 19.1586L8.74416 20.5576C9.44369 21.1572 10.543 21.1572 11.2425 20.5576L12.8414 19.1586C13.1412 18.8588 13.7408 18.6589 14.1406 18.6589H15.8394C16.9387 18.6589 17.7382 17.7595 17.7382 16.7602V15.0613C17.7382 14.6616 17.938 14.062 18.2378 13.7622L19.6369 12.1632C20.1366 11.4637 20.1366 10.2645 19.537 9.56496ZM14.1406 8.96536L9.34376 13.7622C9.24383 13.8621 9.04396 13.962 8.84409 13.962C8.64423 13.962 8.44436 13.8621 8.34443 13.7622L5.94603 11.3638C5.64623 11.064 5.64623 10.5643 5.94603 10.2645C6.24583 9.9647 6.7455 9.9647 7.0453 10.2645L8.94403 12.1632L13.0413 7.8661C13.3411 7.5663 13.8408 7.5663 14.1406 7.8661C14.4404 8.1659 14.4404 8.66556 14.1406 8.96536Z",
    fill: "#F46F16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified123);
export default __webpack_public_path__ + "static/media/verified123.4754eafbdb388675b61f1d23d94530cf.svg";
export { ForwardRef as ReactComponent };